export const MIN_WIDTH_TO_COLLAPSE_MENU = 1440;
